import React, { useEffect, useState } from "react";
import Image from "../../../Tags/Image";
import { Skeleton } from "../../../ui/skeleton";
import SearchDropdown from "../../../SearchDropdown";
import { Button } from "../../../ui/button";
import {
  deleteCRMObjectsConfig,
  getCRMObjectList,
  getSavedCRMConfig,
  saveCRMObjectsConfig,
  updateCRMObjectsConfig,
} from "../../../../apis/workspace/integrations";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

export default function ObjectSettings({
  onSuccess,
  onError,
  currentIntegration = {},
  activeWorkspace,
  isSubmitting,
  isLoading,
  getSavedConfig,
  getCurrentConfig,
  getCompaniesArr,
}) {
  const { crmConfigId, crmKey } = useParams();
  const [objectSettingsArr, setObjectSettingsArr] = useState(
    crmKey === "hubspot"
      ? [
          {
            id: "init_1",
            crm_object_api_name: "Companies",
            crm_object_label: "Companies",
            type: "company",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "Company",
          },
          {
            id: "init_2",
            crm_object_api_name: "Contacts",
            crm_object_label: "Contacts",
            type: "person",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "People Contacts",
          },
          {
            id: "init_3",
            crm_object_api_name: "Task",
            crm_object_label: "Task",
            type: "voice_call",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "Voice Call",
          },
        ]
      : [
          {
            id: "init_1",
            crm_object_api_name: "Account",
            crm_object_label: "Account",
            type: "company",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "Company",
          },
          {
            id: "init_2",
            crm_object_api_name: "Lead",
            crm_object_label: "Lead",
            type: "person",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "People - Lead",
          },
          {
            id: "init_3",
            crm_object_api_name: "Contact",
            crm_object_label: "Contact",
            type: "person",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "People - Contact",
          },
          {
            id: "init_4",
            crm_object_api_name: "Task",
            crm_object_label: "Task",
            type: "voice_call",
            permission: {
              create: true,
              update: true,
              view: true,
            },
            name: "Voice Call",
          },
        ]
  );

  const [crmObjects, setCRMObjects] = useState([]);

  // useEffect(() => {
  //   console.log("objectSettingsArr", { objectSettingsArr, currentObject, savedConfig });
  // }, [objectSettingsArr]);

  // get crm object list
  const getCRMObjectListFn = useMutation("crm_object_list", getCRMObjectList, {
    onSuccess(data, variables, context) {
      // console.log(data);
      setCRMObjects(data);
    },
  });
  const handleGetCRMObjectList = () => {
    getCRMObjectListFn.mutate({
      crmKey: crmKey,
      crmConfigId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id && crmConfigId && crmKey) {
      handleGetCRMObjectList();
    }
  }, [activeWorkspace, crmConfigId, crmKey]);

  const [savedConfig, setSavedConfig] = useState([]);
  const [currentConfig, setCurrentConfig] = useState(null);
  const [companiesArr, setCompaniesArr] = useState([]);

  // get crm object list
  const getSavedCRMConfigFn = useMutation("get_saved_crm_object", getSavedCRMConfig, {
    onSuccess(data, variables, context) {
      // console.log("savedConfig", data);
      if (data && data.data && data.data.length > 0) {
        const objCompany = data?.data.find((obj) => obj.type === "company");
        const objPeople = data?.data.find((obj) => obj.type === "person");

        const arr = data?.data.filter((obj) => obj.type === "company");
        setCompaniesArr(arr);
        getCompaniesArr(arr);
        console.log("saveed config", data?.data);
        setSavedConfig(data?.data);
        getSavedConfig(data?.data);

        // if (!mapActiveTabApi) {
        //   setMapActiveTabApi(objCompany?.crm_object_api_name);
        // }

        setCurrentConfig(objCompany);
        getCurrentConfig(objCompany);

        const sortedArr = data.data
          .sort((a, b) => a.type.localeCompare(b.type)) // Sort by type ('company' first, then 'person', then 'voice_call')
          .map((item, index, arr) => {
            let name = "";

            if (item.type === "company") {
              name = "Company";
            } else if (item.type === "person") {
              const personIndex = arr.slice(0, index).filter((obj) => obj.type === "person").length;

              if (personIndex === 0) {
                name = crmKey === "hubspot" ? "People - Contact" : "People - Lead";
              } else if (personIndex === 1) {
                name = "People - Contact";
              } else {
                name = "People";
              }
            } else if (item.type === "voice_call") {
              name = "Voice Call";
            }

            return {
              id: item.id,
              crm_object_api_name: item.crm_object_api_name,
              crm_object_label: item.crm_object_label,
              type: item.type,
              permission: item.permission,
              name: name, // Add the name key with the calculated value
            };
          });

        const remainingArr = [];
        objectSettingsArr.forEach((item) => {
          const obj = sortedArr.find((el) => el.name === item.name);
          if (!obj) {
            remainingArr.push({ ...item, reinit: true });
          }
        });
        let finalArr = [...sortedArr, ...remainingArr];
        
        // For HubSpot, filter to only show the 3 expected objects (Company, People Contacts, Voice Call)
        if (crmKey === "hubspot") {
          const expectedNames = ["Company", "People - Contact", "Voice Call"];
          finalArr = finalArr.filter(item => expectedNames.includes(item.name));
        }
        
        finalArr.sort((a, b) => a.type.localeCompare(b.type));
        setObjectSettingsArr(finalArr);
      }
    },
  });

  const handleGetSavedCRMConfig = () => {
    getSavedCRMConfigFn.mutate({
      crmKey: crmKey,
      crmConfigId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };
  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id && crmConfigId && crmKey) {
      handleGetSavedCRMConfig();
    }
  }, [activeWorkspace, crmConfigId, crmKey]);

  const [currentObject, setCurrentObject] = useState(null);
  const [currentObjectConfigId, setCurrentObjectConfigId] = useState(null);
  const saveCRMObjectsConfigFn = useMutation("save_crm_object_config", saveCRMObjectsConfig, {
    onSuccess(data, variables, context) {
      toast.success(data?.message);
      setCurrentObjectConfigId(null);
      handleGetSavedCRMConfig();
    },
    onError(error) {
      setCurrentObjectConfigId(null);
    },
  });

  const initSaveCRMObjectsConfigFn = useMutation("init_save_crm_object_config", saveCRMObjectsConfig, {
    onSuccess(data, variables, context) {
      handleGetSavedCRMConfig();
    },
    onError(error) {},
  });

  const handleSaveCRMObjectsConfig = (objectConfigId, remove = false) => {
    setCurrentObjectConfigId(objectConfigId);

    if (remove) {
      deleteCRMObjectsConfigFn.mutate({
        crmKey: crmKey,
        crmConfigId: crmConfigId,
        objectId: objectConfigId,
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }

    let obj = {};
    const arr = objectSettingsArr.filter((item) => item.id === objectConfigId);
    obj = arr && arr.length > 0 && arr[0];

    const payload = {
      crm_object_api_name: obj?.crm_object_api_name,
      crm_object_label: obj?.crm_object_label,
      type: obj?.type,
      permission: obj?.permission,
    };

    if (obj?.crm_object_api_name) {
      saveCRMObjectsConfigFn.mutate({
        crmKey: crmKey,
        crmConfigId: crmConfigId,
        data: { ...payload },
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }
  };

  // delete crm object config
  const deleteCRMObjectsConfigFn = useMutation("delete_crm_object_config", deleteCRMObjectsConfig, {
    onSuccess(data, variables, context) {
      if (currentObject && currentObject.crm_object_api_name === "") {
        toast.success("CRM object unmapped successfully");
        setCurrentObject({});
      }
    },
  });

  const getCurrent = (obj, id) => {
    setCurrentObject({ ...obj, id: id });
    setObjectSettingsArr((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              crm_object_api_name: obj.crm_object_api_name,
              crm_object_label: obj.crm_object_label,
            }
          : item
      )
    );
  };

  const updatePermission = (event, id, obj, permissionType) => {
    const { checked } = event.target;
    setCurrentObject({
      ...obj,
      id: id,
      permission: {
        ...obj.permission,
        [permissionType]: checked,
      },
    });
    setObjectSettingsArr((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              permission: {
                ...item.permission,
                [permissionType]: checked,
              },
            }
          : item
      )
    );
  };

  // send default payload for object settings

  useEffect(() => {
    if (
      !getSavedCRMConfigFn.isLoading &&
      savedConfig.length === 0 &&
      !getCRMObjectListFn.isLoading &&
      crmObjects.length > 0
    ) {
      const isHubspot = crmKey === "hubspot";
      const accountObject = crmObjects.find((item) =>
        item.crm_object_api_name === (isHubspot ? "Companies" : "Account")
      );
      const leadObject = isHubspot
        ? null
        : crmObjects.find((item) => item.crm_object_api_name === "Lead");
      const contactObject = crmObjects.find((item) =>
        item.crm_object_api_name === (isHubspot ? "Contacts" : "Contact")
      );
      const voiceCallObject = crmObjects.find((item) => item.crm_object_api_name === "Task");
      let accountObjectPayload = {};
      let leadObjectPayload = {};
      let contactObjectPayload = {};

      const saveObjects = (payload) => {
        initSaveCRMObjectsConfigFn.mutate({
          crmKey: crmKey,
          crmConfigId: crmConfigId,
          data: { ...payload },
          options: {
            headers: { "X-Workspace-Id": activeWorkspace?.id },
          },
        });
      };

      if (accountObject && accountObject.crm_object_api_name) {
        accountObjectPayload = {
          crm_object_api_name: accountObject?.crm_object_api_name,
          crm_object_label: accountObject?.crm_object_label,
          type: "company",
          permission: {
            create: true,
            update: true,
            view: true,
          },
        };
        saveObjects(accountObjectPayload);
      }
      if (leadObject && leadObject.crm_object_api_name) {
        leadObjectPayload = {
          crm_object_api_name: leadObject?.crm_object_api_name,
          crm_object_label: leadObject?.crm_object_label,
          type: "person",
          permission: {
            create: true,
            update: true,
            view: true,
          },
        };
        saveObjects(leadObjectPayload);
      }
      if (contactObject && contactObject.crm_object_api_name) {
        contactObjectPayload = {
          crm_object_api_name: contactObject?.crm_object_api_name,
          crm_object_label: contactObject?.crm_object_label,
          type: "person",
          permission: {
            create: true,
            update: true,
            view: true,
          },
        };
        saveObjects(contactObjectPayload);
      }
      if (voiceCallObject && voiceCallObject.crm_object_api_name) {
        let voiceCallObjectPayload = {
          crm_object_api_name: voiceCallObject?.crm_object_api_name,
          crm_object_label: voiceCallObject?.crm_object_label,
          type: "voice_call",
          permission: {
            create: true,
            update: true,
            view: true,
          },
        };
        saveObjects(voiceCallObjectPayload);
      }
    }
  }, [savedConfig, getSavedCRMConfigFn.isLoading, crmObjects, getCRMObjectListFn.isLoading]);

  const shouldMapButtonBeDisabled = (item) => {
    const existingObj = savedConfig.find((obj) => obj.crm_object_api_name === item.crm_object_api_name);

    if (
      currentObject &&
      existingObj &&
      currentObject.permission === existingObj.permission &&
      currentObject.id === item.id
    ) {
      return true;
    } else if (
      currentObject &&
      existingObj &&
      currentObject.permission !== existingObj.permission &&
      currentObject.id === item.id
    ) {
      return false;
    } else if (saveCRMObjectsConfigFn.isLoading && item.id === currentObjectConfigId) {
      return true;
    } else if (getCRMObjectListFn.isLoading) {
      return true;
    } else if (existingObj) {
      return true;
    } else {
      return false;
    }
  };

  const updateCRMObjectsConfigFn = useMutation("update_crm_object_config", updateCRMObjectsConfig, {
    onSuccess(data, variables, context) {
      handleGetSavedCRMConfig();
      toast.success("CRM object updated successfully");
    },
    onError(error) {},
  });

  const handleUpdateCRMObjectsConfig = (id, payload) => {
    updateCRMObjectsConfigFn.mutate({
      crmKey: crmKey,
      crmConfigId: crmConfigId,
      objectId: id,
      data: { ...payload },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  return (
    <>
      <div className="space-y-4">
        {objectSettingsArr.map((item) => (
          <div
            key={item.value}
            className="w-full rounded-[--radius] border border-input bg-background text-text-900 py-4 px-6"
          >
            <div className="flex justify-between">
              <div className="inline-flex items-center">
                <span className="text-lg font-bold capitalize">{item.name}</span>
              </div>
            </div>
            <div className="pt-6 px-6 border-t flex items-center mt-4 mb-2 -mx-6">
              <Image src={`/images/logos/integrations/${crmKey}.svg`} width={24} className="no-invert" />
              <span className="text-[14px] text-paragraph leading-relaxed inline-flex ml-2 capitalize">
                {crmKey} Object
              </span>

              <div className="ml-6">
                {getCRMObjectListFn.isLoading ? (
                  <Skeleton className={"rounded-lg h-11 w-[290px]"} />
                ) : (
                  <SearchDropdown
                    data={crmObjects}
                    selected={!item.reinit && item.crm_object_api_name}
                    getCurrent={(obj) => {
                      getCurrent(obj, item.id);
                    }}
                    type={item.type}
                  />
                )}
              </div>

              <Button
                className="ml-2"
                disabled={shouldMapButtonBeDisabled(item)}
                onClick={() => {
                  const objInit =
                    savedConfig &&
                    savedConfig.length > 0 &&
                    savedConfig.find((obj) => obj.crm_object_api_name === item.crm_object_api_name);
                  const objUpdated =
                    objectSettingsArr &&
                    objectSettingsArr.length > 0 &&
                    objectSettingsArr.find((obj) => obj.crm_object_api_name === item.crm_object_api_name);
                  if (objInit && objUpdated && objInit.permission !== objUpdated.permission) {
                    handleUpdateCRMObjectsConfig(objUpdated.id, {
                      crm_object_api_name: objUpdated?.crm_object_api_name,
                      crm_object_label: objUpdated?.crm_object_label,
                      type: objUpdated?.type,
                      permission: objUpdated?.permission,
                    });
                  } else {
                    if (item.id.includes("init")) {
                      handleSaveCRMObjectsConfig(item.id);
                    } else {
                      handleSaveCRMObjectsConfig(item.id, true);
                    }
                  }
                }}
              >
                Map
                {saveCRMObjectsConfigFn.isLoading && item.id === currentObjectConfigId && (
                  <div className="loader_circle inline-block ml-1"></div>
                )}
              </Button>
            </div>
            <div className="">
              <div className="border-t my-6"></div>
            </div>
            <div>
              <span className="text-base font-bold">Manage Permissions</span>
              <div className="flex space-x-3 items-center mt-4">
                <input
                  checked={item.type === "voice_call" ? true : item.permission?.create}
                  type="checkbox"
                  className={`form-checkbox rounded ${
                    item.type === "voice_call"
                      ? "text-gray-iron-300 cursor-not-allowed bg-gray-100"
                      : "text-brand-700 cursor-pointer"
                  } dark:text-brand-200`}
                  onChange={(e) => {
                    updatePermission(e, item.id, item, "create");
                  }}
                  disabled={item.type === "voice_call"}
                />{" "}
                <span className="text-[14px] text-paragraph leading-relaxed">
                  Create records
                  {item.type === "voice_call"}
                </span>
              </div>
              <div className="flex space-x-3 items-center mt-4">
                <input
                  checked={item.permission?.update}
                  type="checkbox"
                  className="form-checkbox text-brand-700 rounded cursor-pointer dark:text-brand-200"
                  onChange={(e) => {
                    updatePermission(e, item.id, item, "update");
                  }}
                />{" "}
                <span className="text-[14px] text-paragraph leading-relaxed">Update records</span>
              </div>
              <div className="flex space-x-3  items-center mt-4">
                <input
                  checked
                  type="checkbox"
                  className="form-checkbox text-gray-iron-300 rounded cursor-not-allowed dark:text-brand-200"
                  disabled
                />{" "}
                <span className="text-[14px] text-paragraph leading-relaxed">View records</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
